import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

export const useStyles = makeStyles()((theme: Theme) => ({
  controls: {
    margin: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(0),
    },
  },
}));
